let searchbar = {

    // VARS handle searchbar behaviour
    suggestions: '',

    // VARS open secondary searchbar
    hasSearchbar: window.position ? window.position.hasSearchbar.bool : false,
    openTrigger: '',
    closeTrigger: '',
    primary: '',
    secondary: '',

    init: function() {
        searchbar.openTrigger = document.querySelector('.secondary #nav-2 .ico-search');
        searchbar.secondary = document.getElementById('top-searchbar');
        if(searchbar.openTrigger && searchbar.secondary) {
            searchbar.handleOpenClose();
        }

        searchbar.inputSearch = document.getElementById('main-search-input');

        if(searchbar.inputSearch) {
            searchbar.suggestions = document.getElementById('suggestions');
			if (searchbar.suggestions) {
				searchbar.inputSearch.addEventListener('focus', searchbar.showSuggestions);
				searchbar.inputSearch.addEventListener('blur', searchbar.hideSuggestions);
			}

            let form = document.getElementById('searchform');
            
            // Single selects case
            const fields = ['where_field', 'metier_field', 'financement_field', 'modalite_field'];
            for (const field of fields) {
                let el = document.querySelector('#'+field);
                if(el) {
                    new TomSelect('#'+field, {
                        create: false,
                        maxItems: 1,
                        closeAfterSelect: true,
                        hidePlaceholder: true,
                        render: {
                            option_create: function(data, escape) {
                                return '<div class="create">Ajouter <strong>' + escape(data.input) + '</strong>&hellip;</div>';
                            },
                            no_results:function(data,escape) {
                                return '<div class="no-results">Aucun résultat "'+escape(data.input)+'"</div>';
                            },
                        }
                    });
                    el.addEventListener('change', function(e) {
                        let form = document.getElementById('searchform');
                        let target = e.target.closest("#metier_field, #financement_field, #modalite_field");
                        if(target) {
                            let cf = document.querySelector('#cf');
                            if(cf) {
                                cf.setAttribute('form','searchform');
                            }
                        }
                        if(form) {
                            form.submit();
                        }
                    });
                }
            }
            
            // Multiple selects case
            const multifields = ['prerequis_field'];
            for (const field of multifields) {
                let el = document.querySelector('#'+field);
                if(el) {
                    let multiselect = new TomSelect('#'+field, {
                        create: false,
                        maxItems: null,
                        closeAfterSelect: false,
                        hidePlaceholder: true,
                        persist: true,
                        plugins: {
                            'checkbox_options' : {
                                'checkedClassNames':   ['ts-checked'],
                                'uncheckedClassNames': ['ts-unchecked'],
                            },
                            'clear_button': {
                                'title' : 'Supprimer tous les pré-requis',
                            }
                        },
                        render: {
                            option_create: function(data, escape) {
                                return '<div class="create">Ajouter <strong>' + escape(data.input) + '</strong>&hellip;</div>';
                            },
                            no_results:function(data,escape) {
                                return '<div class="no-results">Aucun résultat "'+escape(data.input)+'"</div>';
                            },
                        },
                        onInitialize: function() {
                            let clearBtn = document.querySelectorAll('.clear-button')[0];
                            if (this.items.length > 0) {
                                clearBtn.style.display = 'inline-block';
                            }
                        },
                        onBlur:function() {
                            if (form && this.items.length > 0) {
                                form.submit();
                            }
                        },
                        onChange: function() {
                            let clearBtn = document.querySelectorAll('.clear-button')[0];
                            if (this.items.length > 0) {
                                clearBtn.style.display = 'inline-block';
                            } else {
                                clearBtn.style.display = 'none';
                            }
                        },
                        onClear: function() {
                            if (form) {
                                form.submit();
                            }
                        }
                    });
                }
            }

        }
    },

    showSuggestions: function() {
        searchbar.suggestions.classList.add('active');
    },

    hideSuggestions: function() {
        setTimeout(
            () => {
                searchbar.suggestions.classList.remove('active');
            }, 500
        );
    },

    handleOpenClose: function() {        
        if (searchbar.hasSearchbar && searchbar.openTrigger) {
            searchbar.openTrigger.addEventListener('click', searchbar.scrollTo);
        } else {
            searchbar.closeTrigger = searchbar.secondary.querySelector('.ico-close');
            if(searchbar.openTrigger) {
                searchbar.openTrigger.addEventListener('click', (e) => {
                    e.preventDefault();
                    searchbar.toggle();
                });
            }
            if(searchbar.closeTrigger) {
                searchbar.closeTrigger.addEventListener('click', searchbar.toggle);
            }
            document.addEventListener('click', searchbar.close);
        }
    },

    scrollTo: function(e) {

        // handle close mobile navigation
        let inputCloseMobileMenu = document.getElementById('openclose-navsite');
        if ( inputCloseMobileMenu.checked) {
            inputCloseMobileMenu.checked = false;
        }
        
        e.preventDefault();
        let lastScrollTop = 0;
        let scrollDirection = window.pageYOffset || document.documentElement.scrollTop;
        let positionToScroll = 0;
        searchbar.primary = document.querySelector('.top-search');
        
        if (scrollDirection > lastScrollTop){
            positionToScroll = searchbar.primary.getBoundingClientRect().top - document.documentElement.getBoundingClientRect().top - 120;
        } else {
            positionToScroll = searchbar.primary.getBoundingClientRect().top - 120;
        }
        window.scrollTo({top: positionToScroll, behavior: "smooth"});
        lastScrollTop = scrollDirection <= 0 ? 0 : scrollDirection;
        

    },
    
    close: function(e) {
        let hasClose = !searchbar.secondary.classList.contains('close');
        if (hasClose && e.target !== (searchbar.openTrigger || searchbar.closeTrigger)) {
            let inTarget = !searchbar.secondary.contains(e.target);
            if (inTarget) {
                searchbar.toggle();
            }
        }
    },

    toggle: function() {
        searchbar.secondary.classList.toggle('close');  
    }
};

document.addEventListener('DOMContentLoaded', searchbar.init);